import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { partnerGuideUrl } from '../../utils/partnerGuide';

// Slim shell for an outside lawyer who certifies POAs. The queue, their own
// statistics and details, and their guide (its own site, signed in with this same account),
// nothing else: no cases, support or Finanças queue. The backend refuses those to a
// certifier anyway; this keeps the UI from offering them.
const CertifierLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { currentUser, logout } = useAuth();
  return (
    <div className="coepi-container">
      <header className="coepi-header">
        <div className="logo">Coepi Partner</div>
        <div className="user-profile">
          <span>{currentUser?.email}</span>
          <button onClick={logout} className="logout-button">Sign Out</button>
        </div>
      </header>
      <main className="coepi-main">
        <aside className="sidebar">
          <div className="welcome-message">
            <h2>Welcome Back, {currentUser?.displayName || 'Partner'}.</h2>
          </div>
          <nav className="task-nav" aria-label="Certification">
            <ul>
              <li><Link to="/certifications">POAs to certify</Link></li>
              <li><Link to="/certifications/statistics">Statistics</Link></li>
              <li><Link to="/certifications/me">My details</Link></li>
              <li>
                <a href={partnerGuideUrl()} target="_blank" rel="noopener noreferrer">Guide</a>
              </li>
            </ul>
          </nav>
        </aside>
        <section className="task-view">{children}</section>
      </main>
    </div>
  );
};

export default CertifierLayout;
